import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Accordion } from "react-bootstrap";
import EachNotification from './EachNotification';

const InventoryNotifConf = (props) =>{
    const t = useTranslate();

    if(props.moduleAdmin.params.inventaire.active){
        return (
            <Accordion className='mb-2'>
                <Accordion.Item eventKey='inventory'>
                    <Accordion.Header>
                        <span style={{color:props.notificationsType.inventory.bg, fontWeight:'bold',fontSize:'0.9rem'}}>
                            {t('inventory')}&nbsp;
                            <i style={{color:props.notificationsType.inventory.bg}} className={`${props.notificationsType.inventory.icon} header-icon fs-5`}></i>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <span>{t('noConfAvailable')}</span>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }else{
        return(<></>)
    }
};

export default InventoryNotifConf;